export const langSessionList = {
  fr: {
    sessions: 'Sessions',
    session: 'Session',
    add: 'Ajouter',
    modify: 'Modifier',
    delete: 'Supprimer',
    search: 'Rechercher',
    // dateTime: 'Date et heure début',
    dateTime: 'Date et Durée',
    date: 'Date',
    duration: 'Durée',
    wind: 'Infos vent',
    maxSessionsReached: `Nombre maxi de sessions enregistrées atteint`,
    noSessions: `Vous n'avez pas de session enregistrée. Pour intégrer les données d'un fichier gpx ou fit, cliquez sur le bouton Ajouter.`,
    registeredOnly: 'Réservé aux utilisateurs enregistrés',
    distance: `Distance (km)`,
    speed: `Vitesse max (knt)`,
    maxSpeedRig: `Gréement vitesse max`,
  },
  eng: {
    sessions: 'Sessions',
    session: 'Session',
    add: 'Add',
    modify: 'Modify',
    delete: 'Delete',
    search: 'Search',
    // dateTime: 'Start date and time',
    dateTime: 'Date and Duration',
    date: 'Date',
    duration: 'Duration',
    wind: 'Wind infos',
    maxSessionsReached: `Maximum number of saved sessions reached`,
    noSessions: `You have no saved sessions. To integrate the data of a gpx or fit file, click on the Add button.`,
    registeredOnly: 'Registered users only',
    distance: `Distance (km)`,
    speed: `Max speed (knt)`,
    maxSpeedRig: `Max speed rig`,
  },
}
